import type { FeatureManifest } from '../registry.js';
import { CupMark } from './rail.js';

/**
 * CP-06 City Cup and Creator Cup (P2, R3), on the monthly event: region totals and creator
 * teams, a public results page to share. Its own flag, `cityCup` (R3: events run in R2 without
 * it; the API routes also need `events`), and the events unlock; the Creator Cup parts also need
 * the `creatorCup` flag (checked in the views).
 */
export default {
  id: 'cups',
  flag: 'cityCup',
  unlock: 'events',
  online: true,
  provides: ['cup', 'creatorCode'],
  entry: { order: 5, icon: CupMark, label: 'feature.cups.rail', testId: 'rail-cups', open: 'cup' },
  load: () => import('./index.js'),
} satisfies FeatureManifest;
